module.exports = __webpack_public_path__ + "static/img/railroad-08a-300x101.7b4b378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/railroad-08a-300x101.png
// module id = OZoe
// module chunks = 1